<template>
    <div
        class="collection"
        :class="classes"
    >
        <component
            :is="component"
            :items="resource"
        />
    </div>
</template>

<script>
import {provide} from "vue";
import component from "@/services/resources/component";
import {useRoute} from 'vue-router'
import Kernel from "@oilstone/kernel";

export default {
    props: {
        type: String,
        resource: Array
    },

    setup(props) {
        const app = Kernel.resolve('context').app;
        const route = useRoute();

        provide('type', props.type);

        return {
            component: component(props.type, route.query.view || app === 'cms' ? 'adminCollection' : 'webCollection'),
        }
    },


    computed: {
        classes() {
            return [`collection-${this.type}`];
        },
    }
}
</script>
